export function getVouchersRoutes() {
  return [
    {
      path: "/vouchers",
      name: "vouchers",
      component: () => import(/* webpackChunkName: vouchers-old-backend */ "./components/VouchersOld.vue"),
    },
  ]
}
